import {css, StyleSheet} from 'aphrodite';
import Backbone from 'backbone';
import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import BenchlingAppDetails from 'benchling-apps/end-user-page/BenchlingAppDetails';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import BenchlingAppTabState from './BenchlingAppTabState';

const styles = StyleSheet.create({
  background: {
    backgroundColor: '#f5f8fa',
  },
});
export default class BenchlingAppTabView extends Backbone.View<BenchlingAppTabState> {
  static initClass(): void {
    this.prototype.className = classNames('buffer-tab buffer-tab--no-padding', css(styles.background));
  }

  render(): this {
    renderToDOM(<BenchlingAppDetails benchlingAppId={this.model.get('benchlingAppId')} />, this.el);
    return this;
  }

  remove(): Backbone.View<BenchlingAppTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

BenchlingAppTabView.initClass();
